import { render } from "./SignUpConfirmView.vue?vue&type=template&id=1f59f66f"
import script from "./SignUpConfirmView.vue?vue&type=script&lang=js"
export * from "./SignUpConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__